import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'GATEKEEPER_POST',
  POST_SUCCESS: 'GATEKEEPER_POST_SUCCESS',
  POST_FAILURE: 'GATEKEEPER_POST_FAILURE',
};

export const bulkGet = actions.post(() => `${BASE_URL}/gatekeeper/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});
